import { render, staticRenderFns } from "./ActiveRegistration.vue?vue&type=template&id=6d89efea"
import script from "./ActiveRegistration.vue?vue&type=script&lang=js"
export * from "./ActiveRegistration.vue?vue&type=script&lang=js"
import style0 from "./ActiveRegistration.vue?vue&type=style&index=0&id=6d89efea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports